<div class="hw">
    <div class="hw-head">
        <span class="hw-icon"><i class="pi pi-desktop"></i></span>
        <div>
            <span class="hw-title">Hardware</span>
            <span class="hw-desc">Devices &amp; accessories on this account</span>
        </div>
    </div>

    <div class="hw-table-wrap">
        <p-table
            styleClass="p-datatable-striped hw-table"
            [autoLayout]="true"
            responsiveLayout="scroll"
            [value]="hardwareObj"
            rowHover="true"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Hardware / Accessories</th>
                    <th style="text-align: center">Qty</th>
                    <th style="text-align: right">Price Including Tax</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">{{ item.qty }}</td>
                    <td style="text-align: right">{{ item.grandPrice | currency | currencySpacing }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3">
                        <div class="hw-empty">
                            <i class="pi pi-inbox"></i>
                            <span>No hardware found.</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
